import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {Wavesbox} from "./wavesbox"

export const wavesboxLoader = function (options = {}) {
    componentLoader(componentConfig(Wavesbox, Wavesbox.config.componentTypeKey, Wavesbox.config.baseHtmlClass), options);
};

